import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import baseURL from '../Common/Config';
import Axiosfetch from '../Common/Axiosfetch';
import Alert from 'react-s-alert';
import FailureAlert from '../Common/Failure';
import * as yup from 'yup';
import {
    validateOrgData, ValidateExistingOrganization,
    CallBackAlert
} from '../Common/Validations/validation';
import IsUndefinedNullOrEmpty from '../Common/Validations/valueCheck';

const OrganizationDetails = {
    Name: "",
    AddressLine1: "",
    AddressLine2: "",
    City: "",
    State: "",
    PostalCode: 0,
    Country: "",
    GSTNumber: "",
    Logo: null,
    Contact: 0,
    AlternateContact: 0,
    Website: "",
    Keywords: "",
    PANNumber: "",
    Status: 0,
    IsDeleted: 0
};

const OrganizationSchema = yup.object().shape({
    Name: yup.string().required().required(),
    AddressLine1: yup.string().trim().required(),
    AddressLine2: yup.string().trim(),
    City: yup.string().trim().required(),
    State: yup.string().trim().required(),
    PostalCode: yup.number().required(),
    Country: yup.string().trim().required(),
    Contact: yup.number().required(),
    GSTNumber: yup.string().trim().required(),
    AlternateContact: yup.number().required(),
    PANNumber: yup.string().required(),
});

const AddOrganizations = ({ themeColor, hideorganization, getOrganization, edit, organizationdetail, allOrganization }) => {
    const [organizationData, setOrganizationData] = useState(OrganizationDetails);
    const [OrgLogo, setOrgLogo] = useState(null);

    useEffect(() => {
        if (parseInt(edit) === 1) {
            setOrganizationData(organizationdetail);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onTextChange = (e) => {
        let value = e.target.value;
        setOrganizationData({ ...organizationData, [e.target.name]: value });
    };

    const onNumberChange = (e) => {
        let value = e.target.value;
        if (value !== "" && !isNaN(value)) {
            setOrganizationData({ ...organizationData, [e.target.name]: parseFloat(value) });
        }
        else {
            setOrganizationData({ ...organizationData, [e.target.name]: 0 });
        }
    };

    const SaveOrgDetails = () => {
        if (!IsUndefinedNullOrEmpty(OrgLogo)) {
            UploadOrganizationFile();
        }
        else {
            SaveOrganization(null);
        }
    };

    const SaveOrganization = (filename) => {
        var orgData = organizationData;
        if (!IsUndefinedNullOrEmpty(filename)) {
            orgData.Logo = filename;
        }

        if (validateOrgData(organizationData)) {
            OrganizationSchema.validate(orgData).then(valid => {
                if (ValidateExistingOrganization(orgData, allOrganization)) {
                    Axiosfetch(baseURL + ((parseInt(edit) === 0) ? "CreateOrganization" : "EditOrganization"), "POST", organizationData, OrgDetailsSuccess, Failure);
                }
            }).catch(err => {
                Alert.error(err.message, {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
            });
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    const OrgDetailsSuccess = (data) => {
        if (data.success) {
            hideorganization();
            getOrganization();
        }

        CallBackAlert(data);
    };

    const UploadOrganizationFile = () => {
        let formData = new FormData();
        formData.append('file', OrgLogo);
        Axiosfetch(baseURL + "UploadOrganizationLogo", "POST", formData, OrgUploadSuccess, Failure);

    };

    const OrgUploadSuccess = (data) => {
        if (data.success) {
            SaveOrganization(data.filename);
        }
        else {
            Alert.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const OnFileUpload = (e) => {
        var selectedFile = e.target.files[0];
        if (selectedFile.type === "image/jpeg" || selectedFile.type === "image/png" ||
            selectedFile.type === "image/jpg") {
            setOrgLogo(selectedFile);
        }
        else {
            Alert.error("File Type allowed are : PNG , JPG, JPEG", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    return (
        <div>
            <div id="addProduct" className="modal" style={{ display: "block", paddingTop: "40px" }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${themeColor}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>{parseInt(edit) === 0 ? "Add" : "Edit"} Organization</span>
                        <span className="close" onClick={hideorganization}>&times;</span>
                    </div>
                    <div style={{ height: "70vh", overflow: "auto", overflowX: "hidden" }}>
                        <table className="table">
                            <tbody>
                                <tr>
                                    <td>
                                        <h5>Name<span className="mandatoryStar">*</span></h5>
                                    </td>
                                    <td>
                                        <input type="text" name="Name"
                                            className="form-control"
                                            onChange={e => onTextChange(e)}
                                            value={organizationData.Name}></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5>AddressLine 1<span className="mandatoryStar">*</span></h5>
                                    </td>
                                    <td>
                                        <input type="text" name="AddressLine1"
                                            className="form-control"
                                            onChange={e => onTextChange(e)}
                                            value={organizationData.AddressLine1}></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5>AddressLine 2</h5>
                                    </td>
                                    <td>
                                        <input type="text" name="AddressLine2"
                                            className="form-control"
                                            onChange={e => onTextChange(e)}
                                            value={organizationData.AddressLine2}></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5>City<span className="mandatoryStar">*</span></h5>
                                    </td>
                                    <td>
                                        <input type="text" name="City"
                                            className="form-control"
                                            onChange={e => onTextChange(e)}
                                            value={organizationData.City}></input>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <h5>State<span className="mandatoryStar">*</span></h5>
                                    </td>
                                    <td>
                                        <input type="text" name="State"
                                            className="form-control"
                                            onChange={e => onTextChange(e)}
                                            value={organizationData.State}></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5>Postal Code<span className="mandatoryStar">*</span></h5>
                                    </td>
                                    <td>
                                        <input type="text" name="PostalCode"
                                            className="form-control"
                                            onChange={e => onNumberChange(e)}
                                            value={organizationData.PostalCode}></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5>Country<span className="mandatoryStar">*</span></h5>
                                    </td>
                                    <td>
                                        <input type="text" name="Country"
                                            className="form-control"
                                            onChange={e => onTextChange(e)}
                                            value={organizationData.Country}></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5>GST Number<span className="mandatoryStar">*</span></h5>
                                    </td>
                                    <td>
                                        <input type="text" name="GSTNumber"
                                            className="form-control"
                                            onChange={e => onTextChange(e)}
                                            value={organizationData.GSTNumber}></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5>PAN Number<span className="mandatoryStar">*</span></h5>
                                    </td>
                                    <td>
                                        <input type="text" name="PANNumber"
                                            className="form-control"
                                            onChange={e => onTextChange(e)}
                                            value={organizationData.PANNumber}></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5>Contact<span className="mandatoryStar">*</span></h5>
                                    </td>
                                    <td>
                                        <input type="text" name="Contact"
                                            className="form-control"
                                            onChange={e => onNumberChange(e)}
                                            value={organizationData.Contact}></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5>Alternate Contact</h5>
                                    </td>
                                    <td>
                                        <input type="text" name="AlternateContact"
                                            className="form-control"
                                            onChange={e => onNumberChange(e)}
                                            value={organizationData.AlternateContact}></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5>Website</h5>
                                    </td>
                                    <td>
                                        <input type="text" name="Website"
                                            className="form-control"
                                            onChange={e => onTextChange(e)}
                                            value={organizationData.Website}></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5>Keywords</h5>
                                    </td>
                                    <td>
                                        <input type="text" name="Keywords"
                                            className="form-control"
                                            onChange={e => onTextChange(e)}
                                            value={organizationData.Keywords}></input>
                                        <span>Comma(,) seperated keywords of City names</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5>Logo</h5>
                                    </td>
                                    <td>
                                        <input type="file" name="Logo"
                                            className="form-control"
                                            onChange={e => OnFileUpload(e)}
                                            accept="image/jpeg, image/png"></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2" style={{ textAlign: "right" }}>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <button type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save ${themeColor}Focus`} onClick={SaveOrgDetails}>Save</button>
                                                <button type="button" className="btn btn-default" onClick={hideorganization}>Close</button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddOrganizations;